import {Component, input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

type Type = 'square' | 'rounded';
type Size = 'small' | 'big';
type ColorVariant = 'primary' | 'secondary' | 'tertiary' | 'outlined-neutral' | 'outlined-cancelled' | 'cancelled';

@Component({
  selector: 'app-text-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './text-button.component.html',
  styleUrl: './text-button.component.scss'
})
export class TextButton {
  type = input<Type>('rounded');
  size = input<Size>('big');
  colorVariant = input<ColorVariant>('primary');

  text = input<string | null>('');

  leadingIcon = input<string | undefined>(undefined);
  trailingIcon = input<string | undefined>(undefined);

  get cssClass() {
    if (this.type() === 'rounded') {
      return `text-button text-button-rounded text-button-${this.colorVariant()}`;
    }

    return `text-button text-button-${this.size()} text-button-${this.colorVariant()}`;
  }

  get matButtonType() {
    if (this.type() === 'square' || this.colorVariant() === 'tertiary' || this.colorVariant().startsWith('outlined-')) {
      return 'outlined';
    }

    return 'filled'
  }
}
